

import React from 'react';
import flatten from 'lodash.flatten';
import isEmpty from 'lodash.isempty';
import { FormModal } from '../../../../../ui-kit';
import CustomAddonsSection from './CustomAddonsSection';
import AddonsFinalSelection from './AddonsFinalSelection';
import { getCurrencySymbol as getCurrencySymbolUtil } from '../../../utils';

import '../styles/_workspace-addon-costs-modal.scss';


















export default class WorkspaceAddonCostsModal extends React.Component

{
  constructor(props) {
    super(props);

    this.state = {
      selectedAddons: []
    };
  }

  getTotalAddons = () => {
    const { selectedAddons } = this.state;
    const selectedCount = !isEmpty(selectedAddons) ?
    selectedAddons.map(({ addonValues }) => addonValues.
    reduce((count, { selected }) => count + (selected === true), 0)) :
    [0];

    const totalCount = selectedCount.reduce((sum, counts) => sum + counts, 0);

    return totalCount;
  };

  onSelectedAddon = (selectedAddons) => {
    this.setState({ selectedAddons });
  };

  filterAddons = (accumulator, addonValues) => {
    const { billingEntityCode } = this.props;
    const getCurrencySymbol = getCurrencySymbolUtil(billingEntityCode);
    const costPrefix = `${getCurrencySymbol()}`;

    const addons = {
      label: addonValues.label,
      prefix: addonValues?.icon ? addonValues.icon : addonValues.prefix
    };

    if (addonValues.selected) {
      accumulator.push({ ...addons, cost: costPrefix + 0 });
    }

    if (addonValues.costChanged) {
      accumulator.push({ ...addons, cost: costPrefix + addonValues.cost });
    }

    return accumulator;
  };

  onApplyChanges = () => {
    const { onIncludedAddons, onSelectedAddons, onClose } = this.props;
    const { selectedAddons } = this.state;

    const updatedAddons = selectedAddons.
    map(({ addonValues }) => addonValues.reduce(this.filterAddons, []));

    onIncludedAddons(flatten(updatedAddons));
    onSelectedAddons(selectedAddons);

    onClose();
  };

  render() {
    const {
      visible,
      onClose,
      CAPTIONS,
      updatedAppliedAddons,
      billingEntityCode,
      addonsWithCosts,
      onChangedBillingEntityCode,
      selectedBillingEntityCode
    } = this.props;

    const finalCostComponent =
    <AddonsFinalSelection
      totalAddon={this.getTotalAddons()}
      onClose={onClose}
      onApplyChanges={this.onApplyChanges} />;



    return (
      <FormModal
        title="Manage Add-ons"
        visible={visible}
        showCancelBtn={false}
        className="workspace-addon-costs-modal"
        footerChildren={finalCostComponent}
        onClose={onClose}
        size="MD">

        <div className="workspace-addon-costs-modal__container">
          <CustomAddonsSection
            CAPTIONS={CAPTIONS}
            onSelectedAddon={this.onSelectedAddon}
            updatedAppliedAddons={updatedAppliedAddons}
            billingEntityCode={billingEntityCode}
            addonsWithCosts={addonsWithCosts}
            onChangedBillingEntityCode={onChangedBillingEntityCode}
            selectedBillingEntityCode={selectedBillingEntityCode} />

        </div>
      </FormModal>);

  }
}